import { render, staticRenderFns } from "./actionsWidget.vue?vue&type=template&id=2f2c5afa&scoped=true&lang=pug&"
import script from "./actionsWidget.vue?vue&type=script&lang=js&"
export * from "./actionsWidget.vue?vue&type=script&lang=js&"
import style0 from "./actionsWidget.vue?vue&type=style&index=0&id=2f2c5afa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c5afa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VRow})
